module.exports = __webpack_public_path__ + "img/bt-3-off.288e1c14.png";